document.addEventListener('DOMContentLoaded', () => {
    // Fonction pour gérer l'interaction vidéo/bouton
    const handleVideoInteraction = (section) => {
        const video = section.querySelector('.mm-absolute-media');
        const playButton = section.querySelector('.mm-text-image-media-play');

        if (video && playButton) {
            // Ajouter un événement sur le bouton
            playButton.addEventListener('click', () => {
                if (video.paused) {
                    video.muted = false; // Désactiver le mode muet
                    video.play();        // Démarrer la vidéo
                    playButton.style.display = 'none'; // Masquer le bouton
                }
            });

            // Ajouter un événement sur la vidéo pour la pause
            video.addEventListener('click', () => {
                if (!video.paused) {
                    video.pause();       // Mettre en pause la vidéo
                    playButton.style.display = 'block'; // Afficher le bouton
                }
            });
        }
    };

    // Récupérer toutes les sections pertinentes
    const sections = document.querySelectorAll('.mm-text-image[data-section-text-image-id]');
    sections.forEach(handleVideoInteraction);
});
